export enum SkuModalSection {
    Head = "head",
    Body = "body",
    Footer = "foot",
    None = ""
}